var $          = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var _          = require('lodash');
var lazysizes  = require('lazysizes/lazysizes.min');

var breakpoint = 1023;
var container  = '.card--events, .card--banner';
var content    = '.card__content';
var background = '.background-image';
var ratio      = 1;
var ratios     = {
    'card--events': 1,
    'card--banner': 1.3
};
var maxHeights = {
    'card--events': 386,
    'card--banner': 286
};



$('.isotope-layout--rides').find(container).find(background).each(function(index, bgImage) {
    lazySizes.loader.unveil(bgImage);
});


var resize = _.debounce(function(e) {
    $(container).each(function() {

        // Apply the Card Height Ratio
        // ----------------------------------------------------------

        // Determine the Ratio
        thisContainer = $(this);
        _.each(ratios, function(ratioValue, className) {
            if (thisContainer.hasClass(className)) {
                ratio = ratioValue;
            }
        });

        // Determine the Max Height
        maxHeight = 9999;
        _.each(maxHeights, function(maxHeightValue, className) {
            if (thisContainer.hasClass(className)) {
                maxHeight = maxHeightValue;
            }
        });

        // Set height for all cards in a section to apply the ratio of the first card's with
        width  = Math.max.apply(Math, $(this).parents('section').find(container).map(function(){
           return $(this).width();
        }).get());
        height = Math.min(maxHeight, width * ratio);
        $(this).find(background).height(height);


        // Position the Card Content
        // ----------------------------------------------------------
        if ($(window).width() > breakpoint) {
            // Calculate the height of the card__content
            offset = $(this).find(content).outerHeight(true);

            // Move the card__content inside the card
            $(this).find(content).css('top', -offset);

            // Resize container to remove bottom white space (where the card__content used to be)
            $(this).css('margin-bottom', -offset);
        }
        else {
            // Reset card__content position (outside of the card)
            $(this).find(content).each(function() {
                $(this).css('top', '');
            });

            // Reset container margin
            $(this).css('margin-bottom', '');
        }
    });


    // Redraw isotope
    $(window).trigger('isotope-redraw');

}, 100);

$(window).on('load resize', _.bind(resize));

module.exports  = function() { /* Nothing to Export */ };
